import { AppRouteProps } from '@bsm/component'
import { InvoiceContainer } from './container/InvoiceContainer'
import { InvoiceListRoutes } from 'views/list/InvoiceListRoutes'
import { InvoiceDetailsRoute } from 'views/details/InvoiceDetailsRoute'

export const InvoiceRoutes: Array<AppRouteProps> = [
    {
        path: "",
        element: <InvoiceContainer />,
        children: [
            ...InvoiceDetailsRoute,
            ...InvoiceListRoutes,
        ]
    }
]
